import { ref } from "vue";
import { getMyAccount } from "@/services/accountService";

// Create a reactive user store
const user = ref(null);
const permissions = ref([]);
const isSuperuser = ref(false);
const isStaff = ref(false);
const userOrg = ref();
// Becomes true after the first successful loadUser() resolves. Used by views
// to defer rendering 403 placeholders until perms are actually known, which
// stops the brief 403 flash on page refresh.
const permissionsLoaded = ref(false);

export const useStore = {
  // State getters
  getUser: () => user.value,
  getPermissions: () => permissions.value,
  isSuperuser: () => isSuperuser.value,
  isStaff: () => isStaff.value,
  isServiceProviderUser: () => user.value?.org_is_service_provider === true,
  userOrg: () => userOrg.value,
  permissionsLoaded: () => permissionsLoaded.value,
  permissionsLoadedRef: permissionsLoaded,

  // Actions
  async loadUser() {
    try {
      const userData = await getMyAccount();
      user.value = userData;
      permissions.value = userData.permissions || [];
      isSuperuser.value = userData.is_superuser || false;
      isStaff.value = userData.is_staff || false;
      userOrg.value = userData.org_name;
      permissionsLoaded.value = true;
      return userData;
    } catch (error) {
      console.error("Failed to load user data:", error);
      return null;
    }
  },

  clear() {
    user.value = null;
    permissions.value = [];
    isSuperuser.value = false;
    isStaff.value = false;
    permissionsLoaded.value = false;
  },

  // Optional helper methods
  hasPermission(permission) {
    return permissions.value.includes(permission);
  },

  hasAnyPermission(permissionList) {
    return permissionList.some((permission) =>
      permissions.value.includes(permission)
    );
  },

  hasAllPermissions(permissionList) {
    return permissionList.every((permission) =>
      permissions.value.includes(permission)
    );
  },
};
